export default __webpack_public_path__ + "payment-services.webp";